<template>
  <Badge :variant="labelColorCoding" :size="small ? 'small' : 'medium'" :label="props.status" :dot="true" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { BadgeVariant, Badge } from '@tallo/design-system';
import { PropertyStatus } from '@tallo/property';

const props = defineProps<{
  status: PropertyStatus;
  small?: boolean;
}>();

const statusColorMap = new Map<PropertyStatus, BadgeVariant>([
  [PropertyStatus.DRAFT, 'grey'],
  [PropertyStatus.LISTED, 'green'],
  [PropertyStatus.READY_FOR_LISTING, 'violet'],
  [PropertyStatus.LISTING_IN_PROGRESS, 'blue'],
  [PropertyStatus.RENTED_OUT, 'yellow'],
  [PropertyStatus.UNLISTED, 'grey-dark'],
]);

const labelColorCoding = computed(() => statusColorMap.get(props.status));
</script>
